export default {
  path: '',
  component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
  children: [
    {
      path: '/distributor/train/front/home',
      name: 'distributor-train-front-home',
      component: () => import('./index.vue'),
    },
  ]
};
